<template>
  <div
    class="relative flex flex-col min-w-0 mb-4 lg:mb-0 mt-4 break-words bg-white border border-gray-200 dark:bg-gray-800 w-full shadow-lg rounded"
  >
    <div class="rounded-t mb-0 px-0 border-0">
      <CardHeader :title="title" />

      <div class="flex flex-wrap items-center px-4 pb-2">
        <div class="w-full pt-1">
          <ul class="my-1 space-y-3 text-sm text-gray-700 dark:text-gray-200">

            <!-- Active Courses -->
            <li v-if="subscriptions.activeCourses !== undefined">
              <strong>{{ subscriptions.activeCourses }}</strong> active courses
            </li>

            <!-- Users -->
            <li v-if="subscriptions.licenseCount !== undefined && subscriptions.usedLicenses !== undefined">
              <strong>{{ subscriptions.usedLicenses }}</strong> / {{ subscriptions.licenseCount }} user licenses used
            </li>

            <!-- Branches -->
            <li v-if="subscriptions.branchLimit !== undefined && subscriptions.usedBranches !== undefined">
              <strong>{{ subscriptions.usedBranches }}</strong> / {{ subscriptions.branchLimit }} branches used
            </li>

            <!-- Subscription status -->
            <li v-if="subscriptions.subscriptionStatus">
              Subscription status: <strong>{{ subscriptions.subscriptionStatus }}</strong>
            </li>

            <!-- Subscription ends -->
            <li v-if="subscriptions.subscriptionEndsAt">
              Subscription ends: <strong>{{ formatDate(subscriptions.subscriptionEndsAt) }}</strong>
            </li>

            <!-- Trial ends -->
            <li v-if="subscriptions.trialEndsAt">
              Trial ends: <strong>{{ formatDate(subscriptions.trialEndsAt) }}</strong>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHeader from '@/partials/CardHeader.vue';

export default {
  components: {
    CardHeader,
  },
  props: {
    title: String,
    subscriptions: {
      type: Object,
      default: () => ({
        activeCourses: 0,
        activeUsers: 0,
      }),
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    },
  },
};
</script>
